export default "__VITE_ASSET__DNlFuROS__"